import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginModule } from './shared/login/login.module';
import { LoginComponent } from './shared/login/login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from './shared/auth/auth.module';
import { NotfoundComponent } from './shared/notfound/notfound.component';
import { HqModule } from './hq/hq.module';
import { StoreModule } from './store/store.module';
import { AuthenticationService } from './shared/auth/authentication.service';

export function loadHqModule() {
  return HqModule;
}

// { path: 'hq', loadChildren: loadHqModuleFn },

@NgModule({
  declarations: [
    AppComponent,
    NotfoundComponent,
  ],
  imports: [
    BrowserModule,
    AuthModule,
    RouterModule.forRoot([
      { path: '', redirectTo: 'login', pathMatch: 'full'},
      // TODO: get lazy loading back up
      // { path: 'hq', loadChildren: 'app/hq/hq.module#HqModule', pathMatch: 'prefix'},
      { path: 'hq', loadChildren: loadHqModule},
      { path: 'store', loadChildren: 'app/store/store.module#StoreModule', pathMatch: 'prefix'},
      { path: 'login', component: LoginComponent },
      { path: '404', component: NotfoundComponent },
      { path: '**', redirectTo: '404' }
    ]),
    LoginModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
  ],
  bootstrap: [AppComponent],
  providers: [AuthenticationService],
  exports: [RouterModule],
})
export class AppModule { }



// WEBPACK FOOTER //
// /app/src/app/app.module.ts